import { combineReducers } from "redux";

import Country from "./Country";

export default combineReducers({
  Country,
});
